import './logger';
import init from './init';

init();
